import { readValueAtKeys } from '../schema-address';
import { SchemaRootResolver } from './schema-root';

/** `$data` — the data of the state the place bound, where a leaf reads its own value from. A value it lacks is silent. */
export const dataRoot: SchemaRootResolver = {
  resolve: (address, scope) => readValueAtKeys(scope.state()?.data, address.keys),

  dataOf: (keys) => ({ from: 'node', keys }),
};
